/**
 * @file
 */

import wxGuide from './wechatJump';
import scrollList from './scrollList';
const components = [
    wxGuide,
    scrollList
];

const install = (Vue) => {
    if (install.installed) {
        return;
    }

    components.forEach(component => {
        if (typeof component.install === 'function') {
            component.install(Vue);
        } else {
            Vue.component(component.name, component);
        }
    });

    const EventBus = new Vue();
    Object.defineProperties(Vue.prototype, {
        $bus: {
            get() {
                return EventBus;
            }
        }
    });
};
export {
    install
};